"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import {
  PaymentBrowsersModel,
  PaymentCountriesModel,
  PaymentLanguagesModel,
  PaymentOperatingOsModel,
  PaymentOperatingUaModel,
  PaymentResolutionModel,
  PaymentTimezonesModel
} from "./paymentNewComputerConfig.model";
export let PaymentSelectedModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.filterName = "";
    this.searchParams = null;
    this.searchLoading = false;
    //loading 状态
    //区域
    this.types = null;
    this.regions = null;
    this.areas = null;
    this.remotes = null;
    this.models = null;
    //vd
    this.categorysLoading = false;
    //loading 状态
    this.categorys = null;
    //时长
    this.goods = null;
    //环境配置
    this.configCountrie = new PaymentCountriesModel();
    //国家
    // configSystem:PaymentOperatingSystemsModel = new PaymentOperatingSystemsModel();//操作系统版本（eg: win10-64）
    this.configOs = new PaymentOperatingOsModel();
    //os
    this.configUseragent = new PaymentOperatingUaModel();
    //useragent
    this.configSystemUnify = false;
    //是否使用一套操作系统，默认false
    this.configSystemUnifyOs = null;
    //一套操作系统时os版本
    this.configSystemUnifyUa = null;
    //一套操作系统时ua版本
    this.configSystemWindows = "";
    //windows操作系统版本
    this.configSystemWindowsUa = null;
    //windows操作系统ua
    this.configSystemMac = "";
    //mac操作系统版本
    this.configSystemMacUa = null;
    //mac操作系统ua
    this.configSystemAndroid = "";
    //android操作系统版本
    this.configSystemAndroidUa = null;
    //android操作系统ua
    this.configSystemLinux = "";
    //linux操作系统版本（暂时不展示，但是需传值）
    this.configSystemLinuxUa = null;
    //linux操作系统ua（暂时不展示，但是需传值）
    this.configBrowser = new PaymentBrowsersModel();
    //浏览器类型（暂时弃用）
    this.configAutoResolution = true;
    //自动分辨率（跟随系统分辨率），默认true
    this.configResolution = new PaymentResolutionModel();
    //分辨率
    this.configShowAutoResolution = true;
    //自动分辨率开关是否显示（暂时废弃）
    this.configTimezone = new PaymentTimezonesModel();
    //时区
    this.configAutoTimezone = false;
    //自动时区，默认false（暂时废弃）
    this.configShowAutoTimezone = false;
    //自动时区开关是否显示（暂时废弃）
    this.configLanguage = new PaymentLanguagesModel();
    //语言
    //带续费的vd们
    this.virtualDesktopInfo = new Array();
    //其他
    this.paymentLoading = false;
    //loading 状态
    this.paymentCodeError = null;
    //优惠码输入错误的提示
    this.paymentCodeType = null;
    //折扣码类型(判断是折扣码还是优惠券)
    this.paymentCoupon = null;
    //使用的优惠券对象
    this.paymentVdcard = null;
    //使用的vd卡对象
    this.paymentGoldbeanLimit = 0;
    //金豆使用限制
    this.paymentGoldbeanCoins = 0;
    //金豆余额
    this.paymentGoldbeanLeft = 0;
    //剩余金豆数量
    this.paymentAgreement = false;
    //是否同意许可协议
    this.paymentAutoRenew = false;
    //是否自动续费开关
    this.paymentShowAutoRenew = false;
    //是否显示自动续费开关(疑似未使用？)
    this.paymentDiscountCode = "";
    //折扣码
    this.paymentType = "alipay";
    //支付方式
    this.paymentShowPaypal = false;
    //是否显示paypal支付方式
    this.paymentGoldbeanUsed = 0;
    //支付时的金豆
    this.paymentQuantity = 1;
    //购买的数量
    this.paymentOriginalCost = 0;
    //原价
    this.paymentCost = 0;
    //价格
    this.paymentDesc = "";
  }
  //计算价格公式
};
PaymentSelectedModel.model = "payment.default";
PaymentSelectedModel = __decorateClass([
  Annotation.ModelMeta
], PaymentSelectedModel);
